import BaseComponentController from '.././base-component.controller';

class UserValidateComponentController extends BaseComponentController {

    constructor(userDetailsService, _, componentRegistryService, $q, userService) {
        super(_, componentRegistryService, $q);
        this.loading = false;
        this.curtinId = null;
        this.vm = {
            errors:[],
            fullName:null,
            positionTitle:null,
            faculty:null
        };
        this.userDetailsService = userDetailsService;
        this.userService = userService; 
    }

    init() {
        this.userDetails = null;
        this.loading = false;
        this.curtinId = this._.isEmpty(this.model) ? null : this.model.curtinId;
        this.vm = {
            errors:[],
            fullName: this._.isEmpty(this.model) ? null : this.model.fullName,
            positionTitle: this._.isEmpty(this.model) ? null : this.model.positionTitle,
            faculty: this._.isEmpty(this.model) ? null : this.model.division
        };
        this.type = this.isStaff ? "Staff" : "Student";
        this.title = `${this.type} ID`;
    }
    validate(isRequired = true) {
        if (this.readonly || (!isRequired && this._.isEmpty(this.curtinId))){
            return true;
        }

        this.loading = true;
        this.vm = {
            errors: [],
            fullName: null,
            positionTitle: null,
            faculty: null
        };

        if (this._.isEmpty(this.curtinId) || !this._isValidate(this.curtinId)) {
            this.vm.errors = [`Please enter valid ${this.type} ID`];
            this.loading = false;
            return false;
        }

        if (this._isCurrentUser(this.curtinId)) {
            this.vm.errors = [`You cannot enter your ID`];
            this.loading = false;
            return false;
        }

        if (this.onValidate) {
            let parentErrorMessage = this.onValidate({ curtinId: this.curtinId });
            if (parentErrorMessage) {
                this.vm.errors = [parentErrorMessage];
                this.loading = false;
                return false;
            }
        }        

        return this.userDetailsService.getDetails(this.curtinId).then((response) => {
            if (response.status === "Success") {
                this.vm = {
                    errors:[],
                    fullName:response.data.fullName,
                    positionTitle: response.data.positionTitle,
                    faculty:response.data.division
                };               
                this.model = response.data;
                this.loading = false;
                this.afterValidate({ recipient: this.model });
                this.clearInputField();
                return true;
            } else {
                if (response.status === "NotFound") {
                    this.vm.errors = [`${this.type} ID not found`];
                } else {
                    this.vm.errors = [response.data.error];
                }
            }
            this.loading = false;
            return false;
        });
    
    }

    validateAsync() {
        return this.validate(this.required);
    }

    clearInputField() {
        if (this.clearInputAfterValidate) {
            this.curtinId = null;
        }
    }

    clearUserDetails() {
        this.vm = {
            errors: [],
            fullName: null,
            positionTitle: null,
            faculty: null
        };
        this.model = {};
        this.curtinId = null;
    }

    _isValidate(curtinId) {
        return this.isStaff ? curtinId.match(/\d{6}[a-zA-Z0-9]/) : curtinId.match(/\d{8}/);
    }

    _isCurrentUser(curtinId) {
        let currentUserId = this.userService.getCurrentUserId();
        return curtinId.toUpperCase() === currentUserId.toUpperCase();
    }
}

UserValidateComponentController.$inject = ['userDetailsService', '_', 'componentRegistryService', '$q', 'userService'];

export default {
templateUrl: "app/components/user-validate/user-validate.html",
    bindings: {
        isStaff: '<',
        readonly: '<',
        modelName:'@',
        afterValidate:'&',
        noDisplay: '<',
        buttonTitle: '@',
        required: '<',
        clearInputafterValidate: '<',
        onValidate: '&'
    },
controller: UserValidateComponentController
};


// WEBPACK FOOTER //
// ./app/components/user-validate/user-validate.component.js